import classNames from 'classnames';

export function Divider({ className }: { className?: string }) {
  return <div className={classNames('w-full border-b border-gray-200', className)} />;
}
